module.exports = __webpack_public_path__ + "static/play-button-a9b3fd37b2f85eec4136bb5ac2a42117.png";